import { LogOut, Star } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { useMe, useSignOut } from '../../lib/session';
import { Logo } from '../../ui';

export function StudentShell({ children, stars }: { children: ReactNode; stars?: number }) {
  const me = useMe();
  const signOut = useSignOut();
  const name = me.data?.kind === 'student' ? me.data.student.displayName : '';
  return (
    <div className="min-h-dvh">
      <header className="sticky top-0 z-30 border-b border-line/70 bg-canvas/85 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-5xl items-center gap-3 px-4">
          <Link to="/learn" aria-label="Home">
            <Logo className="h-7" />
          </Link>
          <div className="ml-auto flex items-center gap-2">
            {stars !== undefined && (
              <span className="inline-flex h-10 items-center gap-1.5 rounded-full bg-gold-soft px-3.5 font-display font-bold text-[#8a5a06]">
                <Star className="size-4 fill-gold text-gold" aria-hidden />
                {stars}
                <span className="sr-only">stars</span>
              </span>
            )}
            <span className="hidden h-10 items-center rounded-full bg-surface px-4 font-semibold shadow-sm sm:inline-flex">{name}</span>
            <button
              onClick={() => void signOut()}
              className="inline-flex h-10 items-center gap-1.5 rounded-full px-3.5 text-sm font-semibold text-ink-soft hover:bg-brand-soft hover:text-brand"
            >
              <LogOut className="size-4" aria-hidden />
              Sign out
            </button>
          </div>
        </div>
      </header>
      {children}
    </div>
  );
}
